module.exports = __webpack_public_path__ + "static/media/browser.53bf6596.svg";